import { useState, forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { useTheme } from '@vitness/theme';
import { density as densityTokens } from '@vitness/tokens';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  icon?: ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { icon, style, ...props },
  ref,
) {
  const { accentSafe, density } = useTheme();
  const d = densityTokens[density];
  const [focused, setFocused] = useState(false);

  return (
    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
      {icon && (
        <div style={{
          position: 'absolute',
          left: 10,
          pointerEvents: 'none',
          display: 'flex',
          color: 'var(--vn-text-muted)',
        }}>
          {icon}
        </div>
      )}
      <input
        ref={ref}
        onFocus={e => { setFocused(true); props.onFocus?.(e); }}
        onBlur={e => { setFocused(false); props.onBlur?.(e); }}
        style={{
          width: '100%',
          padding: icon
            ? `${d.inputPaddingY}px ${d.inputPaddingX}px ${d.inputPaddingY}px 30px`
            : `${d.inputPaddingY}px ${d.inputPaddingX}px`,
          background: 'var(--vn-surface-input, var(--vn-surface-card))',
          border: `1px solid ${focused ? accentSafe : 'var(--vn-border-default)'}`,
          borderRadius: 6,
          fontFamily: 'var(--vn-font-body)',
          fontSize: 12,
          color: 'var(--vn-text-primary)',
          outline: 'none',
          transition: 'border-color 0.15s',
          ...style,
        }}
        {...props}
      />
    </div>
  );
});
